import { NULL_CONFIDENTIAL_INFORMATION } from '@common/api/graphql/getProjectsGql';
import { isAPIConfidentialInformation } from '@console/common/project/confidentialInformation';
import type { AppState } from '@console/reducers';
import type {
  LocalAPIConfidentialInformation,
  LocalProject
} from '@console/reducers/projects';
import { createSelector } from 'reselect';

const getProjectDetailConfidentialInformation = (state: AppState) =>
  state.projectDetail.confidentialInformation;

export const getConfidentialInformation = createSelector(
  [getProjectDetailConfidentialInformation],
  (confidentialInformation): LocalProject['confidentialInformation'] =>
    confidentialInformation ?? {
      __typename: NULL_CONFIDENTIAL_INFORMATION,
      reason: ''
    }
);

export const getApiConfidentialInformation = createSelector(
  [getConfidentialInformation],
  (confidentialInformation): LocalAPIConfidentialInformation | null =>
    isAPIConfidentialInformation(confidentialInformation)
      ? confidentialInformation
      : null
);
